export enum AdvertiserNation {
  AU = 'AU',
  NZ = 'NZ',
}

export const getAdvertiserNationFromSite = (site: string) => {
  if (site.toUpperCase().includes(AdvertiserNation.NZ)) {
    return AdvertiserNation.NZ;
  }
  return AdvertiserNation.AU;
};

export const isNZ = (site: string) => {
  const advertiserNation = getAdvertiserNationFromSite(site);
  return advertiserNation === AdvertiserNation.NZ;
};
